<template>
  <div class="route-view dark login-from">
    <language-switch />
    <div class="logo">
      <img src="/images/logo.png" />
    </div>
    <div class="panel">
      <div class="panel-content">
        <auth-menu selected-menu="register" />
        <div class="columns is-centered">
          <b-steps
            v-model="activeStep"
            :animated="true"
            :rounded="true"
            :has-navigation="false"
            mobile-mode="compact"
            class="column is-11"
            type="is-success"
          >
            <b-step-item
              step="1"
              icon="fas fa-check"
              :label="$t('register.usernameLabel')"
              :clickable="false"
            >
              <form @submit.prevent="submitPhone">
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.usernameLabel')
                  }}</label>
                  <div class="control has-icons-left">
                    <input
                      v-model="phoneNumber"
                      type="text"
                      :placeholder="$t('login.phoneLabel')"
                      class="input text-center"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-phone"></i>
                    </span>
                  </div>
                </div>
                <div v-if="error !== null" class="error has-text-centered">
                  {{ error }}
                </div>
                <div class="m-t-30">
                  <button type="submit" class="button full-100 is-primary">
                    {{ $t('register.nextBtn') }}
                  </button>
                </div>
              </form>
            </b-step-item>

            <b-step-item
              :visible="registerOTP"
              step="2"
              icon="fas fa-check"
              :label="$t('register.confPhoneLabel')"
              :clickable="false"
            >
              <form @submit.prevent="submitOtp">
                <div class="field">
                  <label for="" class="label">
                    {{ $t('register.otpLabel') }} OTP (ref : {{ otp.otpRef }})
                  </label>
                  <div class="control has-icons-left">
                    <input
                      v-model="otp.otpCode"
                      type="text"
                      placeholder="000000"
                      class="input text-center"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                  </div>
                </div>
                <div v-if="error !== null" class="error has-text-centered">
                  {{ error }}
                </div>
                <div class="m-t-30">
                  <button type="submit" class="button full-100 is-primary">
                    {{ $t('register.nextBtn') }}
                  </button>
                </div>
              </form>
            </b-step-item>

            <b-step-item
              step="3"
              icon="fas fa-check"
              :label="$t('register.profileLabel')"
              :clickable="false"
            >
              <form @submit.prevent="submitProfile">
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.nameLabel')
                  }}</label>
                  <div class="control has-icons-left">
                    <input
                      v-model="name"
                      type="text"
                      placeholder="Smith"
                      class="input text-center"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-id-card-alt"></i>
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.passwordLabel')
                  }}</label>
                  <div class="control has-icons-left">
                    <input
                      v-model="password"
                      type="password"
                      placeholder="xxxxxx"
                      class="input text-center"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fa fa-lock"></i>
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.confirmPasswordLabel')
                  }}</label>
                  <div class="control has-icons-left">
                    <input
                      v-model="confirmPassword"
                      type="password"
                      placeholder="xxxxxx"
                      class="input text-center"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fa fa-lock"></i>
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.sourceLabel')
                  }}</label>
                  <div class="control has-icons-left has-icons-right">
                    <select v-model="sourceCode" class="input text-center">
                      <option value="" selected="selected">{{
                        $t('register.sourceSelect')
                      }}</option>
                      <option
                        v-for="(source, index) in sourceLists"
                        :key="index"
                        :value="source.code"
                      >
                        {{ source.description }}
                      </option>
                    </select>
                    <span class="icon is-small is-left">
                      <i class="fas fa-university"></i>
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fas fa-caret-down"></i>
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.parentLabel')
                  }}</label>
                  <div class="control has-icons-left">
                    <input
                      v-model="inviteCode"
                      type="text"
                      placeholder="4hfudjDB"
                      class="input text-center"
                      :readonly="hasCode"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-user-friends"></i>
                    </span>
                  </div>
                </div>
                <div
                  v-if="error !== null"
                  class="error has-text-centered m-t-30"
                >
                  {{ error }}
                </div>
                <div class="m-t-30">
                  <button type="submit" class="button full-100 is-primary">
                    {{ $t('register.nextBtn') }}
                  </button>
                </div>
              </form>
            </b-step-item>

            <b-step-item
              step="4"
              icon="fas fa-check"
              :label="$t('register.bankData')"
              :clickable="false"
            >
              <form @submit.prevent="submitBank">
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.bankLabel')
                  }}</label>
                  <div class="control has-icons-left has-icons-right">
                    <select
                      v-model="bankCode"
                      class="input text-center"
                      required
                    >
                      <option value="" selected="selected">{{
                        $t('register.bankSelect')
                      }}</option>
                      <option
                        v-for="(bank, index) in bankLists"
                        :key="index"
                        :value="bank.code"
                      >
                        {{ bank.nameTH }}
                      </option>
                    </select>
                    <span class="icon is-small is-left">
                      <i class="fas fa-university"></i>
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fas fa-caret-down"></i>
                    </span>
                  </div>
                  <div v-if="!isLaos" class="m-b-10 small">
                    {{ $t('register.warningBankOne') }}
                    <img
                      :src="require('@/assets/icon/kbank.png')"
                      class="icon-mini"
                    />
                    {{ $t('register.warningBankTwo') }}
                    <img
                      :src="require('@/assets/icon/ktb.png')"
                      class="icon-mini"
                    />
                    {{ $t('register.warningBankThree') }}
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label">{{
                    $t('register.bankAccountNoLabel')
                  }}</label>
                  <div class="control has-icons-left">
                    <input
                      v-model="bankAccountNo"
                      type="text"
                      placeholder="0123456789"
                      class="input text-center"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-money-check"></i>
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label for="" class="label">
                    {{ $t('register.bankAccountNameLabel') }}
                    {{
                      listBankEng.includes(bankCode)
                        ? $t('register.languageTxt')
                        : ''
                    }}
                  </label>
                  <div class="columns is-variable is-1">
                    <div class="column is-6">
                      <div class="control has-icons-left">
                        <input
                          v-model="bankAccountFirstname"
                          type="text"
                          :placeholder="$t('register.accountFirstname')"
                          class="input text-center"
                          v-uppercase
                          required
                        />
                        <span class="icon is-small is-left">
                          <i class="fas fa-user-tie"></i>
                        </span>
                      </div>
                    </div>
                    <div class="column is-6">
                      <div class="control">
                        <input
                          v-model="bankAccountLastname"
                          type="text"
                          :placeholder="$t('register.accountLastname')"
                          class="input text-center"
                          v-uppercase
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="isLaos" class="field">
                  <label for="" class="label">{{
                    $t('register.currencyLabel')
                  }}</label>
                  <div class="control has-icons-left has-icons-right">
                    <select v-model="currency" class="input text-center">
                      <option
                        v-for="(option, index) in currencyLaosOptions"
                        :key="index"
                        :value="option"
                      >
                        {{ option }}
                      </option>
                    </select>
                    <span class="icon is-small is-left">
                      <i class="fas fa-university"></i>
                    </span>
                    <span class="icon is-small is-right">
                      <i class="fas fa-caret-down"></i>
                    </span>
                  </div>
                </div>
                <div v-if="error !== null" class="error has-text-centered">
                  {{ error }}
                </div>
                <div class="m-t-30">
                  <button type="submit" class="button full-100 is-primary">
                    <i class="fas fa-user-edit"></i
                    >{{ $t('register.registerBtn') }}
                  </button>
                </div>
              </form>
            </b-step-item>
          </b-steps>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiAccount from '@/api/account'
import apiLookup from '@/api/lookup'
import apiOtp from '@/api/otp'
import i18n from '../language'

import { getCode, setCode } from '@/utils/register'
import AuthMenu from '@/components/AuthMenu'
import LanguageSwitch from '@/components/LanguageSwitch'

export default {
  name: 'Register',
  components: {
    AuthMenu,
    LanguageSwitch
  },
  props: {
    page: String
  },
  data() {
    return {
      activeStep: 0,
      phoneNumber: '',
      name: '',
      password: '',
      confirmPassword: '',
      sourceCode: '',
      inviteCode: '',
      bankCode: '',
      bankAccountFirstname: '',
      bankAccountLastname: '',
      bankAccountNo: '',
      currency: process.env.VUE_APP_LAOS === 'true' ? 'LAK' : undefined,
      bankLists: [],
      sourceLists: [],
      error: null,
      registerOTP: false,
      otp: {
        otpRef: '',
        otpToken: '',
        otpCode: ''
      },
      isLaos: process.env.VUE_APP_LAOS === 'true',
      currencyLaosOptions: ['LAK', 'BAHT'],
      listBankEng: [], //['KTB', 'TMB', 'BBL'],
      hasCode: false
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  mounted() {
    if (this.$route.query.code) {
      this.inviteCode = this.$route.query.code
      setCode(this.inviteCode)
    }
    if (getCode()) {
      this.inviteCode = getCode()
      this.hasCode = true
    }

    apiLookup.lookupBanks().then(data => {
      this.bankLists = data
    })
    apiLookup.lookupSources().then(data => {
      this.sourceLists = data
    })
    apiLookup.lookupRegisterOTP().then(data => {
      this.registerOTP = data.registerOTP
    })
  },
  methods: {
    async validateUserInfo() {
      try {
        const bankAccountName = this.getBankAccountName()
        await apiAccount.validate(
          this.name,
          this.phoneNumber,
          this.password,
          this.sourceCode,
          this.inviteCode,
          this.bankCode,
          bankAccountName,
          this.bankAccountNo
        )
      } catch (error) {
        this.$buefy.toast.open({
          message: error,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async submitPhone() {
      try {
        if (!this.isLaos && this.phoneNumber.length !== 10) {
          this.$buefy.toast.open({
            message: i18n.t('errorMsg.PHONE_NUMBER_REQUIRE_10_DIGIT'),
            type: 'is-danger',
            duration: 4000
          })
          return
        }

        if (!this.registerOTP) {
          this.activeStep = 2
          return
        }

        const res = await apiOtp.send(this.phoneNumber)
        const { otpRef, otpToken } = res

        if (res.code === 'OTP_VERIFIED') {
          this.activeStep = 2
        } else {
          this.otp = {
            otpRef,
            otpToken
          }
          this.activeStep = 1
        }
      } catch (error) {
        this.$buefy.toast.open({
          message: error,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async submitOtp() {
      try {
        await apiOtp.verify(this.otp.otpToken, this.otp.otpCode)
        this.activeStep = 2
      } catch (error) {
        this.$buefy.toast.open({
          message: error,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async submitProfile() {
      if (!this.name) return false
      if (!this.phoneNumber) return false
      if (!this.password) return false
      if (!this.confirmPassword) return false

      if (this.password !== this.confirmPassword) {
        this.$buefy.toast.open({
          message: i18n.t('register.passwordNotEqualMsg'),
          type: 'is-danger'
        })
        return
      }

      try {
        const bankAccountName = this.getBankAccountName()
        await apiAccount.validate(
          this.name,
          this.phoneNumber,
          this.password,
          this.sourceCode,
          this.inviteCode,
          this.bankCode,
          bankAccountName,
          this.bankAccountNo
        )
        this.activeStep = 3
      } catch (error) {
        this.$buefy.toast.open({
          message: error,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async submitBank() {
      if (!this.bankCode) return false
      if (!this.bankAccountFirstname) return false
      if (!this.bankAccountLastname) return false
      if (!this.bankAccountNo) return false

      await this.register()
    },
    async register() {
      const bankAccountName = this.getBankAccountName()
      if (this.listBankEng.includes(this.bankCode)) {
        const re = /^[A-Z\s]+$/i

        if (!re.test(bankAccountName)) {
          this.$buefy.toast.open({
            message: i18n.t('register.requiredEngLangMsg'),
            type: 'is-danger'
          })

          return
        }
      }

      let loading = this.$loading.show()
      setTimeout(async () => {
        try {
          await apiAccount.register(
            this.name,
            this.phoneNumber,
            this.password,
            this.sourceCode,
            this.inviteCode,
            this.bankCode,
            bankAccountName,
            this.bankAccountNo,
            this.currency
          )
          loading.hide()

          this.$buefy.toast.open({
            message: i18n.t('register.registerSuccessMsg').toString(),
            type: 'is-success'
          })

          setTimeout(() => {
            this.$router.push('/login')
          }, 2000)
        } catch (error) {
          loading.hide()
          this.$buefy.toast.open({
            message: error,
            type: 'is-danger',
            duration: 4000
          })
        }
      }, 200)
    },
    getBankAccountName() {
      return `${this.bankAccountFirstname.trim()} ${this.bankAccountLastname.trim()}`
    }
  }
}
</script>

<style scoped lang="scss">
.box-button {
  justify-content: flex-end;
}
.error {
  min-height: 30px;
}

.icon-mini {
  width: 20px;
  height: auto;
}

::v-deep {
  .step-link {
    color: $text-color !important;
    text-decoration: none;
  }
  .step-title {
    font-size: 0.7rem !important;
    font-weight: 400 !important;
  }
}
</style>
